import { render, staticRenderFns } from "./OrderArsip.vue?vue&type=template&id=7e68b3e7"
import script from "./OrderArsip.vue?vue&type=script&lang=js"
export * from "./OrderArsip.vue?vue&type=script&lang=js"
import style0 from "./OrderArsip.vue?vue&type=style&index=0&id=7e68b3e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports